import {useState} from 'react';
import {useViewerStore} from "../../../store/store";

type SwitchProps = {
    className?: string,
    onClick?: any,
    labelOne: string,
    labelTwo: string,
    property: any
}

const Switch = (props: SwitchProps) => {
    const {className, onClick, labelOne, labelTwo, property} = props;

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const [toggle, setToggle] = useState(false);
    const handleSwitch = () => {
        if (property === 'ObstVer') sceneViewer.setObstAngle();
        else setToggle(!toggle);
    }

    return (
        <>
            <div className='switch'>
                <button className={`switch__toggle ${className} ${toggle && 'toggled'}`} onClick={handleSwitch}
                        id={`switch${property}`}>
                    <span className='switch__labels'>{labelOne}</span>
                    <span className='switch__labels'>{labelTwo}</span>
                </button>
            </div>
        </>
    );
}

export default Switch;